export function isExternalCompany(): boolean {
    return !!sessionStorage.getItem('EXTERNAL_COMPANY_DATA')
}
